import React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Indexes from './Indexes';
import DataLoad from './DataLoad';
import EmailUtility from './EmailUtility';
import Notifications from './Notifications';

const CustomTabPanel = ({ children, value, index, ...other }) => (
    <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
    >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
);

const a11yProps = (index)  => {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
}

const Admin = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        setValue(0);
    }, []);

    return (
        <div className="container py-5">
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="admin-tabs">
                        <Tab label="Indexes" {...a11yProps(0)} />
                        <Tab label="Data Load" {...a11yProps(1)} />
                        <Tab label="Email Utility" {...a11yProps(2)} />
                        <Tab label="Notifications" {...a11yProps(3)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <Indexes />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <DataLoad />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <EmailUtility />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    <Notifications />
                </CustomTabPanel>
            </Box>
        </div>
    );
};

export default Admin;
